import { useContext } from 'react';
import { QueueStore } from '../store/queue-store';
import { RawQueueRowData } from '../store/types-2';
import { assertNonNull } from '../utils/assert-non-null';
import { QueueStateContext } from './queue-state-context';

export function useQueueStore(): QueueStore<RawQueueRowData> {
    const value = useContext(QueueStateContext);
    assertNonNull(value, 'Unexpectedly did not find a queue store instance');
    return value;
}
